export default "__VITE_ASSET__BsFOC6qa__"